import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone } from '@fortawesome/free-solid-svg-icons';

const FloatingContact = () => {
  return (
    <a
      className="floating-contact"
      href="https://wa.me/50240977396"
      target="_blank"
      rel="noreferrer"
      aria-label="Contactar por WhatsApp"
    >
      <FontAwesomeIcon icon={faPhone} />
    </a>
  );
};

export default FloatingContact;
